import Reflux from 'reflux';
import StudentActions from 'actions/Student';
import AppActions from 'actions/App';
import GroupActions from 'actions/Group';
import CourseActions from 'actions/Course';
import SteelCompass from 'services/SteelCompass';

var StudentStore = Reflux.createStore({
  listenables: [StudentActions],
  data: {
    list: [],
    readers: [],
    selection: [],
    sort: {},
    detail: {},
    filter: {},
    total: 0,
    readersLoading: true,
    saving: false
  },
  getInitialState() {
    return this.data;
  },

  init() {
    if (localStorage) {
      var student = JSON.parse(localStorage.getItem('students')) || {};
      if (student.filter) {
        this.data.filter = student.filter;
      }
      if (student.sort) {
        this.data.sort = student.sort;
      }
      this.trigger(this.data);
    }
  },
  serialize() {
    localStorage.setItem(
      'students',
      JSON.stringify({ filter: this.data.filter, sort: this.data.sort })
    );
  },
  getFilter() {
    return this.data.filter;
  },
  onResetFilter() {
    this.data.filter = {};
    this.trigger(this.data);
    this.serialize();
  },
  onSetFilter(filter) {
    Object.assign(this.data.filter, filter);
    this.trigger(this.data);
    this.serialize();
  },
  onResetSort() {
    this.data.sort = {};
    this.trigger(this.data);
    this.serialize();
  },
  onSetSort(sort) {
    Object.assign(this.data.sort, sort);
    this.trigger(this.data);
    this.serialize();
  },
  hasFilter() {
    return (
      !!this.data.filter.courseId ||
      !!this.data.filter.groupId ||
      !!this.data.filter.access ||
      !!this.data.filter.status
    );
  },
  onFetchAll() {
    return SteelCompass.call(
      'search',
      'filterUsers',
      { isRealUser: true },
      response => {
        this.data.list = response.data;
        this.trigger(this.data);
      }
    );
  },
  countByCourseId(courseId) {
    return SteelCompass.call(
      'user',
      'countByCourseId',
      { courseId },
      response => {
        this.data.total = response.data;
        this.trigger(this.data);
      }
    );
  },
  findReaders() {
    this.data = {
      ...this.data,
      readersLoading: true
    };
    this.trigger(this.data);
    return SteelCompass.request('user', 'findReaders', {}).then(
      readers => {
        StudentActions.findReadersComplete(readers);
      },
      error => {
        this.data = {
          ...this.data,
          readers: [],
          readersLoading: false
        };
        this.trigger(this.data);
        AppActions.genericError(error);
      }
    );
  },
  findReadersComplete(readers) {
    this.data = {
      ...this.data,
      readers,
      readersLoading: false
    };
    this.trigger(this.data);
  },
  onFilter(dontUseFilter) {
    var options = {
      sortBy: this.data.sort.property || 'name',
      sortMode: this.data.sort.direction || 'asc',
      isRealUser: this.data.filter.status
        ? this.data.filter.status == 'invited'
        : null
    };

    if (!dontUseFilter) {
      options.courseId = this.data.filter.courseId;
      options.circleId = this.data.filter.circleId;
    }
    this.data.loading = true;
    this.trigger(this.data);
    return SteelCompass.call('search', 'filterUsers', options, response => {
      if (response.isError) {
        StudentActions.genericError(response.errMsg);
      } else {
        StudentActions.filterComplete(response.data);
      }
    });
  },
  onFilterComplete(data) {
    this.data.list = data;
    this.data.loading = false;
    this.trigger(this.data);
  },
  onFindByGroupId(groupId, callback) {
    return SteelCompass.call(
      'user',
      'findByCircleId',
      { circleId: groupId, sortBy: 'name', sortMode: 'asc' },
      response => {
        this.data.list = response.data || [];
        this.trigger(this.data);
        if (callback) {
          callback();
        }
      }
    );
  },
  onFindByCourseId(courseId, pageStart, pageLength) {
    return SteelCompass.request(
      'user',
      'findByCourseId',
      { courseId, sortBy: 'name', sortMode: 'asc' },
      pageStart,
      pageLength
    ).then(students => {
      StudentActions.findByCourseIdComplete(students);
    });

    // return SteelCompass.request('search', 'filterUsers', { courseId, isRealUser: true, sortBy : name, sortMode : 'asc' }).then(students => {
    //   StudentActions.findByCourseIdComplete(students);
    // });
  },
  onFindByCourseIdComplete(students) {
    this.data.selection = students;
    this.trigger(this.data);
  },
  onFindById(id) {
    this.data.loading = true;
    this.trigger(this.data);
    return SteelCompass.request('user', 'findById', { id }).then(
      response => {
        if (response.isError) {
          StudentActions.genericError(response.errMsg);
        } else {
          StudentActions.findByIdComplete({
            ...response
          });
        }
      },
      error => {
        StudentActions.genericError(error);
      }
    );
  },
  onFindByIdComplete(student) {
    this.data.loading = false;
    this.data.student = student;
    this.trigger(this.data);
  },
  onDelete(groupId, revokeAccess, callback) {
    return SteelCompass.call(
      'user',
      'delete',
      { id: groupId, revokeAccess: revokeAccess },
      response => {
        if (callback && !response.isError) {
          callback();
        }
      }
    );
  },
  onRemoveFromCourse(courseId, userId) {
    return SteelCompass.request('user', 'removeFromCourse', {
      courseId: courseId,
      userId: userId
    }).then(
      response => {
        StudentActions.removeFromCourseComplete(userId, courseId);
      },
      error => {
        AppActions.genericError(error);
      }
    );
  },
  onRemoveFromCourseComplete(userId, courseId) {
    const { selection } = this.data;
    for (var i = selection.length; i--; ) {
      if (selection[i].id === userId) {
        selection.splice(i, 1);
      }
    }
    CourseActions.removeFromSelection(courseId);
    this.trigger(this.data);
  },
  onRemoveFromGroup(groupId, userId) {
    return SteelCompass.request('user', 'removeFromCircle', {
      circleId: groupId,
      userId: userId
    }).then(
      response => {
        StudentActions.removeFromGroupComplete(userId, groupId);
      },
      error => {
        AppActions.genericError(error);
      }
    );
  },
  onRemoveFromGroupComplete(userId, groupId) {
    const { selection } = this.data;
    for (var i = selection.length; i--; ) {
      if (selection[i].id === userId) {
        selection.splice(i, 1);
      }
    }
    GroupActions.removeFromSelection(groupId);
    this.trigger(this.data);
  },
  onRemoveTag(userId, name) {
    return SteelCompass.request('tag', 'removeLink', {
      objectType: 1,
      objectId: userId,
      name
    }).then(
      response => {
        StudentActions.removeTagComplete(userId, name);
      },
      error => {
        AppActions.genericError(error);
      }
    );
  },
  onRemoveTagComplete(userId, name) {
    this.data = {
      ...this.data,
      list: this.data.list.map(user => {
        if (user.id === userId) {
          const tagsMap = user.tagsMap || {};
          return {
            ...user,
            tagsMap: {
              ...tagsMap,
              [name]: false
            }
          };
        }
        return user;
      })
    };
    if (this.data.selection.id === userId) {
      const tagsMap = this.data.selection.tagsMap || {};
      this.data = {
        ...this.data,
        selection: {
          ...this.data.selection,
          tagsMap: {
            ...tagsMap,
            [name]: false
          }
        }
      };
    }
    if (this.data.student.id === userId) {
      const tagsMap = this.data.student.tagsMap || {};
      this.data = {
        ...this.data,
        student: {
          ...this.data.student,
          tagsMap: {
            ...tagsMap,
            [name]: false
          }
        }
      };
    }
    this.trigger(this.data);
  },
  export(options) {
    return SteelCompass.request('user', 'export', options).then(
      response => {
        StudentActions.exportComplete(response);
      },
      error => {
        AppActions.genericError(error);
      }
    );
  },
  exportComplete() {
    AppActions.translatableMessage('student.exportDone');
  },
  exportStatistic(options) {
    return SteelCompass.request('course', 'getTasksReport', options).then(
      response => {
        StudentActions.exportStatisticComplete(response);
      },
      error => {
        AppActions.genericError(error);
      }
    );
  },
  exportStatisticComplete() {
    AppActions.translatableMessage('student.exportStatisticDone');
  },
  onAddTag(userId, name) {
    return SteelCompass.request('tag', 'addLink', {
      objectType: 1,
      objectId: userId,
      name
    }).then(
      response => {
        StudentActions.addTagComplete(userId, name);
      },
      error => {
        AppActions.genericError(error);
      }
    );
  },
  onAddTagComplete(userId, name) {
    this.data = {
      ...this.data,
      list: this.data.list.map(user => {
        if (user.id === userId) {
          const tagsMap = user.tagsMap || {};
          return {
            ...user,
            tagsMap: {
              ...tagsMap,
              [name]: true
            }
          };
        }
        return user;
      })
    };
    if (this.data.selection.id === userId) {
      const tagsMap = this.data.selection.tagsMap || {};
      this.data = {
        ...this.data,
        selection: {
          ...this.data.selection,
          tagsMap: {
            ...tagsMap,
            [name]: true
          }
        }
      };
    }
    if (this.data.student.id === userId) {
      const tagsMap = this.data.student.tagsMap || {};
      this.data = {
        ...this.data,
        student: {
          ...this.data.student,
          tagsMap: {
            ...tagsMap,
            [name]: true
          }
        }
      };
    }
    this.trigger(this.data);
  },
  update(userId, roleValues) {
    this.data = {
      ...this.data,
      saving: true
    };
    this.trigger(this.data);
    return SteelCompass.request('user', 'update', {
      id: userId,
      roles: roleValues
    }).then(
      () => {
        StudentActions.updateComplete(userId, roleValues);
      },
      error => {
        AppActions.genericError(error);
      }
    );
  },
  updateComplete(userId, roleValues) {
    if (this.data.student.id === userId) {
      this.data.student.roles[roleValues] = true;
    } 
    
    this.data = {
      ...this.data,
      saving: false
    };

    this.trigger(this.data);
    AppActions.translatableMessage('user.updated');
  },
  expel(id) {
    return SteelCompass.request('user', 'expel', { id }).then(
      response => {
        StudentActions.expelComplete(id);
      },
      error => {
        AppActions.genericError(error);
      }
    );
  },
  expelComplete() {
    AppActions.translatableMessage('student.expelDone');
  }
});

export default StudentStore;



// WEBPACK FOOTER //
// ./src/js/stores/Student.js